import { render, staticRenderFns } from "./StockChart.vue?vue&type=template&id=311fe070&scoped=true&"
import script from "./StockChart.vue?vue&type=script&lang=js&"
export * from "./StockChart.vue?vue&type=script&lang=js&"
import style0 from "./StockChart.vue?vue&type=style&index=0&id=311fe070&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311fe070",
  null
  
)

export default component.exports